import React from 'react';
import type { VerificationUnit } from '../graphql/generated/graphql';
import yearSensitiveDateString from '../utils/yearSensitiveDateString';
import * as styles from './VerificationModal.module.scss';
import { calculateExpirationTimestamp } from './verificationDateHelpers';

interface VerificationModalNoticeProps {
  children(dateString: string): React.ReactNode;
  unit: VerificationUnit;
  quantity: number;
  verifiedAt?: string;
}

export const VerificationModalNotice = ({
  verifiedAt,
  children,
  unit,
  quantity,
}: VerificationModalNoticeProps) => {
  const expirationTimestamp = calculateExpirationTimestamp(verifiedAt, {
    unit,
    quantity,
  }).getOrElse(() => null);

  if (!expirationTimestamp) return null;

  return (
    <div className={styles.notice}>
      {children(yearSensitiveDateString(expirationTimestamp))}
    </div>
  );
};

export const VerificationModalHr = () => <hr className={styles.hr} />;
